import apiClient from './api';

export default {
    async getShipments(params = {}) {
        return (await apiClient.get('/shipments', { params })).data;
    },

    async getShipment(id) {
        return (await apiClient.get(`/shipments/${id}`)).data;
    },

    async getShipmentsByOrder(orderId) {
        return (await apiClient.get(`/shipments/order/${orderId}`)).data;
    },

    async createShipment(data) {
        return (await apiClient.post('/shipments', data)).data;
    },

    async deleteShipment(id) {
        return (await apiClient.delete(`/shipments/${id}`)).data;
    }
};
